import React from 'react';
import Collapsible from 'react-collapsible';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component
import Button from 'react-toolbox/lib/button';
import Input from 'react-toolbox/lib/input';// to use input from react-toolbox library
import Error from 'components/ErrorMessage';// to display error messages on invalid user input
import { RadioGroup, RadioButton } from 'react-toolbox/lib/radio';
import { is, Map } from 'immutable'; // use of immutablejs for various js operations to simplify our work
import renderIf from 'render-if';// to use conditional rendering based on values that is provided to component
import Autocomplete from 'react-toolbox/lib/autocomplete';
import AutocompleteReact from 'react-autocomplete';
import { regExForName, regExForNumber } from 'constants/Regularexpression'; // regular expressions to validate user input
import { states, offensivePositions, defensivePositions, specialTeamsPositions, actSuggestions } from 'constants/DropdownsValues';
import FullScreenLoader from 'components/FullScreenLoader';// to show loder on screen whenever there is a api call or operations in component
import styles from './ModifyStudent.scss';// to import local scss fle
import theme from './theme.css';

const emptyObject = {};

const autostyle = {
  item: {
    padding: '2px 6px',
    cursor: 'default',
  },

  highlightedItem: {
    color: 'white',
    background: '#eeeeee',
    padding: '2px 6px',
    cursor: 'default',
  },
};

const t40Suggestions = {};
const squatsSuggestions = {};
const benchSuggestions = {};
const gpaSuggestions = {};
const satSuggestions = {};

class ModifyProfile extends React.Component {
  static propTypes = {
    getSAProfile: PropTypes.func,
    saveSAProfile: PropTypes.func,
    attributes: PropTypes.shape(),
    profile: PropTypes.shape(),
    saRequested: PropTypes.bool,
    updateRequested: PropTypes.bool,
    redirect: PropTypes.bool,
    history: PropTypes.shape(),
    searchSchools: PropTypes.func,
    schools: PropTypes.shape(),
  };

  static defaultProps = {
    getSAProfile: () => {},
    saveSAProfile: () => {},
    attributes: {},
    profile: {},
    saRequested: true,
    updateRequested: false,
    searchSchools: () => {},
    redirect: false,
    push: PropTypes.func.isRequired,
    history: {
      push: () => {},
    },
    schools: {},
  };
  constructor(props) {
    super(props);
    this.state = {
      value: '',
            /* student info fields */
      studentFullName: '',
      studentCity: '',
      studentState: '',
      twitter: '',
      mobile: '',
      instagram: '',
      hbcu: 'no',
      studentFullNameErrorMessage: '',
      studentEmailErrorMessage: '',
      studentStateErrorMessage: '',
      studentCityErrorMessage: '',
      twitterErrorMessage: '',
      instagramErrorMessage: '',
      mobileErrorMessage: '',
      secondaryDefensiveError: '',
            /* student info fields */

            /* student sports info */
      position_pref: '',
      height: '',
      weight: '',
      sportName: 'FOOTBALL',
      t40: '',
      bench: '',
      squats: '',
      position: '',
      description: '',
      heightErrorMessage: '',
      heightInchesErrorMessage: '',
      heightInFeetErrorMessage: '',
      weightErrorMessage: '',
      offensiveErrorMessage: '',
      defensiveErrorMessage: '',
      mySport: 'FOOTBALL',
      t40ErrorMessage: '',
      squatsErrorMessage: '',
      benchErrorMessage: '',
      specialTeamsErrorMessage: '',
      specialTeams: '',
      descriptionErrorMessage: '',
      secondaryOffensiveError: '',
      secondaryPosition: [],
      showSecondaryButton: false,
      primary_offensive_position_pref: '',
      secondary_offensive_position_pref: '',
      primary_defensive_position_pref: '',
      secondary_defensive_position_pref: '',
      special_teams: '',
            /* student sports info */

            /* academic info */
      school: {},
      schoolNames: [],
      gpa: '',
      act: '',
      sat: '',
      yearOfPassing: '',
      schoolErrorMessage: '',
      positionErrorMessage: '',
      yearOfPassingErrorMessage: '',
      gpaErrorMessage: '',
      satErrorMessage: '',
      actErrorMessage: '',
            /* academic info */
      parentCollapsible: true,
      emailErrorMessage: '',
      firstNameErrorMessage: '',
    };
    this.validateInput = this.validateInput.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleQueryChange = this.handleQueryChange.bind(this);
    this.handleQueryChangeT40 = this.handleQueryChangeT40.bind(this);
    this.handleWeight = this.handleWeight.bind(this);
    this.handleHeight = this.handleHeight.bind(this);
    this.addAnotherPreference = this.addAnotherPreference.bind(this);
    this.removeSecondaryPosition = this.removeSecondaryPosition.bind(this);
    this.timer = null;
    this.Map = Map;
    this.is = is;
  }

  componentWillMount() {
    if (this.props.attributes.size > 0 && !this.props.profile.size > 0) {
      const profile = this.props.attributes.get('profile');
      this.props.getSAProfile(profile);
    } else {
      const newState = {};

      const saSports = this.props.profile.get('sports');
      const keys = saSports.keySeq().toArray();
      const sport = saSports.get(keys[0]);
      if (sport.get('primary_offensive_position_pref') !== undefined) {
        newState.primary_offensive_position_pref = sport.get('primary_offensive_position_pref');
      }
      if (sport.get('primary_defensive_position_pref') !== undefined) {
        newState.primary_defensive_position_pref = sport.get('primary_defensive_position_pref');
      }
      if (sport.get('secondary_offensive_position_pref') !== undefined) {
        newState.secondary_offensive_position_pref = sport.get('secondary_offensive_position_pref');
      }
      if (sport.get('secondary_defensive_position_pref') !== undefined) {
        newState.secondary_defensive_position_pref = sport.get('secondary_defensive_position_pref');
      }
      if (sport.get('special_teams') !== undefined) {
        newState.special_teams = sport.get('special_teams');
      }
      if (this.props.profile.get('sa_twitter') !== undefined) {
        newState.twitter = this.props.profile.get('sa_twitter');
      }
      if (this.props.profile.get('sa_instagram') !== undefined) {
        newState.instagram = this.props.profile.get('sa_instagram');
      }
      const academic = this.props.profile.get('academic');
      const combinedHeight = this.props.profile.get('height');
      newState.height = this.props.profile.get('height');
      newState.studentFullName = this.props.profile.get('fullname');
      newState.email = this.props.profile.get('sa_email');
      newState.studentGender = this.props.profile.get('gender');
      newState.studentState = this.props.profile.get('sa_state');
      newState.studentCity = this.props.profile.get('city');
      newState.heightInFeet = combinedHeight.charAt(0);
      newState.heightInInches = (combinedHeight.substr(2, 2)).replace(/['"]+/g, '');
      newState.weight = this.props.profile.get('weight');
      newState.sportName = keys[0];
      newState.t40 = sport.get('t40');
      newState.bench = sport.get('bench');
      newState.squats = sport.get('squats');
      newState.description = sport.get('description');
      newState.position = sport.get('position_pref');
      newState.school = this.props.profile.get('school');
      newState.yearOfPassing = academic.get('year_of_graduation');
      newState.gpa = academic.get('gpa');
      newState.hbcu = academic.get('hbcu');
      if (academic.get('sat') !== undefined) {
        newState.sat = academic.get('sat');
      }
      if (academic.get('act') !== undefined) {
        newState.act = academic.get('act');
      }
      newState.mobile = this.props.profile.get('sa_mobile');
      this.setState({ ...newState });
    }
  }

  componentWillReceiveProps(nextProps) {
    if ((this.props.redirect !== nextProps.redirect) && nextProps.redirect === true) {
      this.props.history.push('/view/athlete');
    }
    if (is(this.props.profile, nextProps.profile) && nextProps.saRequested &&
        is(this.props.schools, nextProps.schools)) {
      if (nextProps.attributes.size > 0) {
        const profile = nextProps.attributes.get('profile');
        this.props.getSAProfile(profile);
      }
    } else if (this.Map.isMap(nextProps.schools) && !this.is(nextProps.schools, this.props.schools) && nextProps.schools.get('hits')) {
      const hits = nextProps.schools.get('hits');
      const total = hits.get('total');
      const tempHits = [];
      if (total > 0) {
        let results = nextProps.schools.get('hits');
        results = results.get('hits');
        results = results.toJS();

        results.forEach((school) => {
          const obj = {};
          const college = school._source.school; // eslint-disable-line
          const key = college;
          obj.key = key;
          obj.value = college;
          tempHits.push(obj);
        });
        this.setState({ schoolNames: tempHits });
      }
    }

    const newState = {};
    if (nextProps.profile.size > 0 && !is(this.props.profile, nextProps.profile)) {
      const saSports = nextProps.profile.get('sports');
      const keys = saSports.keySeq().toArray();
      const sport = saSports.get(keys[0]);
      if (sport.get('primary_offensive_position_pref') !== undefined) {
        newState.primary_offensive_position_pref = sport.get('primary_offensive_position_pref');
      }
      if (sport.get('primary_defensive_position_pref') !== undefined) {
        newState.primary_defensive_position_pref = sport.get('primary_defensive_position_pref');
      }
      if (sport.get('secondary_offensive_position_pref') !== undefined) {
        newState.secondary_offensive_position_pref = sport.get('secondary_offensive_position_pref');
      }
      if (sport.get('secondary_defensive_position_pref') !== undefined) {
        newState.secondary_defensive_position_pref = sport.get('secondary_defensive_position_pref');
      }
      if (sport.get('special_teams') !== undefined) {
        newState.special_teams = sport.get('special_teams');
      }
      if (nextProps.profile.get('sa_twitter') !== undefined) {
        newState.twitter = nextProps.profile.get('sa_twitter');
      }
      if (nextProps.profile.get('sa_instagram') !== undefined) {
        newState.instagram = nextProps.profile.get('sa_instagram');
      }
      const academic = nextProps.profile.get('academic');
      const combinedHeight = nextProps.profile.get('height');
      newState.height = nextProps.profile.get('height');
      newState.studentFullName = nextProps.profile.get('fullname');
      newState.email = nextProps.profile.get('sa_email');
      newState.studentGender = nextProps.profile.get('gender');
      newState.studentState = nextProps.profile.get('sa_state');
      newState.studentCity = nextProps.profile.get('city');
      newState.heightInFeet = combinedHeight.charAt(0);
      newState.heightInInches = (combinedHeight.substr(2, 2)).replace(/['"]+/g, '');
      newState.weight = nextProps.profile.get('weight');
      newState.sportName = keys[0];
      newState.t40 = sport.get('t40');
      newState.bench = sport.get('bench');
      newState.squats = sport.get('squats');
      newState.description = sport.get('description');
      newState.position = sport.get('position_pref');
      newState.school = nextProps.profile.get('school');
      newState.yearOfPassing = academic.get('year_of_graduation');
      newState.mobile = nextProps.profile.get('sa_mobile');
      newState.gpa = academic.get('gpa');
      if (academic.get('hbcu') !== undefined) {
        newState.hbcu = academic.get('hbcu');
      }
      if (academic.get('sat') !== undefined) {
        newState.sat = academic.get('sat');
      }
      if (academic.get('act') !== undefined) {
        newState.act = academic.get('act');
      }
    }
    this.setState({ ...newState });
  }
  handleChange(name, value) {
    this.setState({ ...this.state, [name]: value });
  }

  handleQueryChange(val) {
    this.setState({ ...this.state, [val]: '' });
  }

  handleQueryChangeT40(val) {
    if (this.state.t40.length === 3) {
      this.setState({ ...this.state, t40: '' });
    } else {
      this.setState({ ...this.state, t40: val });
    }
  }

  removeErrorMessage(name) {
    this.setState({ ...this.state, [name]: '' });
  }

  validateInput() {
    const { studentFullName, studentCity, studentState } = this.state;
    const updated = {};
        /* validation for student info */
    let validStudentFullName = false;
    let validMobile = false;
    let validStudentCity = false;
    let validStudentState = false;
        /* validation for Full Name */
    const enteredStudentFullName = regExForName.test(studentFullName);
    if (enteredStudentFullName && studentFullName !== '') {
      validStudentFullName = true;
    } else {
      updated.studentFullNameErrorMessage = 'Please enter a valid name.';
    }
        /* validation for Full Name */

        /* validation for city */
    const enteredStudentCity = regExForName.test(studentCity);
    if (enteredStudentCity && studentCity !== '') {
      validStudentCity = true;
    } else {
      updated.studentCityErrorMessage = 'Please enter a valid city.';
    }
        /* validation for city */

      /* Validation for mobile */
    const enteredMobile = regExForNumber.test(this.state.mobile);
    if (enteredMobile && this.state.mobile !== '') {
      validMobile = true;
    } else {
      this.setState({ mobileErrorMessage: 'Please enter a valid mobile number.' });
    }
      /* Validation for mobile */
        /* validation for state */
    const enteredStudentState = (typeof studentState === 'string');
    if (enteredStudentState && studentState !== '') {
      validStudentState = true;
    } else {
      updated.studentStateErrorMessage = 'Please enter a valid state.';
    }
        /* validation for student info */

        /* validation for sports info */
        /* Height Validation */
    let validHeight = false;
    if (this.state.height !== '') {
      validHeight = true;
    } else {
      updated.heightErrorMessage = 'Enter valid height.';
    }
        /* Height Validation */


      /* weight validation */
    let validWeight = false;
    if (this.state.weight !== '' && this.state.weight >= 120 && this.state.weight <= 350) {
      validWeight = true;
    } else if (!(this.state.weight >= 120 && this.state.weight <= 350) && this.state.weight !== '') {
      this.setState({ weightErrorMessage: 'Enter weight between 120-350 pounds.' });
    } else {
      this.setState({ weightErrorMessage: 'Please  add a valid weight.' });
    }
      /* weight validation */

        /* T40 validation */
    let validT40 = false;
    if (this.state.t40 !== '' && this.state.t40 >= 4 && this.state.t40 <= 5.5) {
      validT40 = true;
    } else if (!(this.state.t40 >= 4 && this.state.t40 <= 5.5) && this.state.t40 !== '') {
      this.setState({ t40ErrorMessage: 'Enter 40-Yard Dash between 4-5.5 seconds.' });
    } else {
      this.setState({ t40ErrorMessage: 'Please add a valid 40-Yard Dash.' });
    }

        /* T40 validation */

        /* squats validation */
    let validSquats = false;
    if (this.state.squats !== '' && !isNaN(this.state.squats)) {
      validSquats = true;
    } else {
      updated.squatsErrorMessage = 'Please add a valid Squats.';
    }
        /* squats validation */

        /* Bench validation */
    let validBench = false;
    if (this.state.bench !== '' && !isNaN(this.state.bench)) {
      validBench = true;
    } else {
      updated.benchErrorMessage = 'Please add a valid Bench.';
    }
        /* squats validation */
        /* validation for sports info */

        /* validation for academic info */
    let validSchool = false;
    const enteredScool = typeof this.state.school;
    if (enteredScool === 'string' && this.state.school !== '') {
      validSchool = true;
    } else {
      updated.schoolErrorMessage = 'Please select a school.';
    }
        /* school validation */

        /* year of passing */
    let validYearOfPassing = false;

    if (this.state.yearOfPassing !== '' && !isNaN(this.state.yearOfPassing)) {
      validYearOfPassing = true;
    } else {
      updated.yearOfPassingErrorMessage = 'Please add graduation year';
    }
        /* year of passing */

        /* Gpa validation */
    let validGpa = false;
    if (this.state.gpa !== '' && !isNaN(this.state.gpa) && this.state.gpa >= 2 && this.state.gpa <= 4) {
      validGpa = true;
    } else {
      updated.gpaErrorMessage = 'Please select a Gpa from list.';
    }
        /* Gpa validation */

        /* Act validation */
    let validAct = false;
    if (this.state.act !== '' && this.state.act >= 16 && this.state.act <= 36) {
      validAct = true;
    } else if (this.state.act === '') {
      validAct = true;
    } else {
      this.setState({ actErrorMessage: 'Enter Act between 16 - 36.' });
    }
        /* Act validation */

        /* Sat validation */
    let validSat = false;
    if (this.state.sat !== '' && this.state.sat >= 600 && this.state.sat <= 1600) {
      validSat = true;
    } else if (this.state.sat === '') {
      validSat = true;
    } else {
      this.setState({ satErrorMessage: 'Enter Sat between 600 - 1600.' });
    }

    let validPrimaryPosition = false;
    if (this.state.primary_defensive_position_pref !== '' || this.state.primary_offensive_position_pref !== '') {
      validPrimaryPosition = true;
    } else {
      updated.offensiveErrorMessage = 'Please select one primary position.';
    }

    let validSecondaryPositionCase = false;
    if (this.state.secondary_defensive_position_pref !== ''
        && this.state.primary_defensive_position_pref === '') {
      validSecondaryPositionCase = false;
      updated.secondaryDefensiveError = 'Please fill primary defensive first.';
    } else if (this.state.primary_defensive_position_pref === '' ||
        this.state.secondary_defensive_position_pref === '') {
      validSecondaryPositionCase = true;
    } else if (this.state.primary_offensive_position_pref !== ''
        && this.state.primary_defensive_position_pref !== ''
    ) {
      validSecondaryPositionCase = true;
    }

    let validSamePositionsOffensive = false;
    if (this.state.secondary_offensive_position_pref === '') {
      validSamePositionsOffensive = true;
    } else if (this.state.primary_offensive_position_pref
        === this.state.secondary_offensive_position_pref) {
      validSamePositionsOffensive = false;
      updated.secondaryOffensiveError = 'Primary and secondary positions can not be same.';
    } else if (this.state.secondary_offensive_position_pref !== '') {
      validSamePositionsOffensive = true;
    }

    let validSamePositionsDefensive = false;
    if (this.state.secondary_defensive_position_pref === '') {
      validSamePositionsDefensive = true;
    } else if (this.state.primary_defensive_position_pref
          === this.state.secondary_defensive_position_pref) {
      validSamePositionsDefensive = false;
      updated.secondaryDefensiveError = 'Primary and secondary positions can not be same.';
    } else if (this.state.secondary_defensive_position_pref !== '') {
      validSamePositionsDefensive = true;
    }
        /* Sat validation */
        /* validation for academic info */
    const { yearOfPassing, gpa, sat, act, sportName, t40, school, height, weight,
            bench, squats,
            instagram, twitter, mobile,
            primary_offensive_position_pref, primary_defensive_position_pref,
            secondary_offensive_position_pref, secondary_defensive_position_pref,
            special_teams, hbcu } = this.state;
    const academic = {
      year_of_graduation: yearOfPassing,
      gpa,
      hbcu,
    };
    if (act !== '') {
      academic['act'] = act; //eslint-disable-line
    }
    if (sat !== '') {
      academic['sat'] =sat; //eslint-disable-line
    }

    const sports = {};
    let payload = this.props.profile.toJS();
    sports[sportName] = { t40, bench, squats };
    const temp = sports[sportName];
      if (primary_offensive_position_pref !== '') { //eslint-disable-line
          temp['primary_offensive_position_pref'] = primary_offensive_position_pref; //eslint-disable-line
      }
      if (primary_defensive_position_pref !== '') { //eslint-disable-line
          temp['primary_defensive_position_pref'] = primary_defensive_position_pref; //eslint-disable-line
      }
      if(secondary_defensive_position_pref !== ''){ //eslint-disable-line
          temp['secondary_defensive_position_pref'] = secondary_defensive_position_pref; //eslint-disable-line
      }
      if(secondary_offensive_position_pref !== ''){ //eslint-disable-line
          temp['secondary_offensive_position_pref'] = secondary_offensive_position_pref; //eslint-disable-line
      }
      if(special_teams !== ''){ //eslint-disable-line
          temp['special_teams'] = special_teams; //eslint-disable-line
      }
    sports[sportName] = temp;
    this.setState(updated, () => {
      payload = Object.assign(payload, {
        city: studentCity,
        sa_state: studentState,
        school,
        height,
        weight,
        year_of_graduation: yearOfPassing,
        academic,
        sports,
        sa_mobile: mobile,
        fullname: studentFullName,
        current_division: 'NA',
      });
      if (instagram) {
        let instagramUrl = '';
        if (instagram.startsWith('https')) {
          instagramUrl = instagram;
        } else {
          instagramUrl = `https://instagram.com/${instagram}`;
        }
          payload['sa_instagram'] = instagramUrl; //eslint-disable-line
      } else {
          payload['sa_instagram'] = null; //eslint-disable-line
      }
      if (twitter) {
        let twitterUrl = '';
        if (twitter.startsWith('https')) {
          twitterUrl = twitter;
        } else {
          twitterUrl = `https://twitter.com/${twitter}`;
        }
          payload['sa_twitter'] = twitterUrl; //eslint-disable-line
      } else {
          payload['sa_twitter'] = null; //eslint-disable-line
      }
      if (validStudentFullName && validStudentCity && validStudentState
                && validHeight && validWeight && validT40 && validBench
                && validSquats && validSat && validAct && validGpa && validYearOfPassing
                && validSchool && validMobile && validPrimaryPosition && validSamePositionsDefensive
                && validSecondaryPositionCase && validSamePositionsOffensive) {
        this.props.saveSAProfile(payload, this.state.profile);
      }
    });
  }
  handleWeight = (name, value) => {
    this.setState({ ...this.state, [name]: value.target.value });
  };
  handleHeight = (name, value) => {
    if (name === 'heightInFeet') {
      if ((value.target.value <= 7 && value.target.value >= 4) || value.target.value === '') {
        this.setState({ ...this.state, [name]: value.target.value }, () => {
          this.setState({ height: `${this.state.heightInFeet}'${this.state.heightInInches}"` });
        });
      }
    } else if ((value.target.value < 12 && value.target.value >= 0) || value.target.value === '') {
      this.setState({ ...this.state, [name]: value.target.value }, () => {
        this.setState({ height: `${this.state.heightInFeet}'${this.state.heightInInches}"` });
      });
    }
  };
  addAnotherPreference() {
        let tempData = []; // eslint-disable-line
    tempData = [
      {
        id: 'OFFENSIVE',
        positionValue: '',
      }, {
        id: 'DEFENSIVE',
        positionValue: '',
      },
    ];
    this.setState({ secondaryPosition: tempData, showSecondaryButton: false });
  }

  addValuesToSecondaryPosition(value, i) {
    let tempData = [];
    tempData = this.state.secondaryPosition;
    tempData[i].positionValue = value;
    this.setState({ secondaryPosition: tempData });
  }

  removeSecondaryPosition(name) {
    if (name === 'secondary_defensive_position_pref') {
      this.setState({ ...this.state, [name]: '', secondaryDefensiveError: '' });
    } else {
      this.setState({ ...this.state, [name]: '', secondaryOffensiveError: '' });
    }
  }

  schoolSearch(name, value) {
    const query = {};
    if (this.timer) { clearTimeout(this.timer); }

    this.setState({ ...this.state, [name]: value });

    if (value && value.length >= 3) {
      this.timer = setTimeout(() => {
        const obj = {};
        obj.key = 'school';
        obj.value = value;
        query.push(obj);
        this.props.searchSchools(query);
      }, 100);
    }
  }
  render() {
        for (let i = 1; i < 5; i++) { //eslint-disable-line
            for (let x = 0; x <= 10; x++) { //eslint-disable-line
              let listItem = '';
              listItem = ((i * 100) + (x * 10));
              squatsSuggestions[`${listItem}`] = `${listItem}`;
            }
        }
        for (let i = 1; i < 4; i++) { //eslint-disable-line
            for (let x = 0; x <= 10; x++) { //eslint-disable-line
              let listItem = '';
              listItem = ((i * 100) + (x * 10));
              benchSuggestions[`${listItem}`] = `${listItem}`;
            }
        }
      for(let i = 4;i<6;i++){ //eslint-disable-line
          for(let x = 0;x<=10;x++) { //eslint-disable-line
            let listItem = '';
              listItem = `${i + "." + x}`; // eslint-disable-line
            if (x === 10) {
                  listItem = `${i+1}.0`; // eslint-disable-line
            }
            if (listItem <= '5.5') {
              if (listItem === '4.0') {
                listItem = '4.0 or Lower';
              } else if (listItem === '5.5') {
                listItem = '5.5 or Higher';
              }
              t40Suggestions[`${listItem}`] = `${listItem}`;
            }
          }
      }
      for(let i = 6;i<16;i++){ //eslint-disable-line
          for(let x = 1;x<=10;x++) { //eslint-disable-line
            let listItem = '';
            let left = '';
            let right = '';
            listItem = ((i * 100) + (x * 10));
            left = listItem;
            right = listItem;
            if (listItem === 600) { left = '600'; right = '600 or Lower'; }
            satSuggestions[`${left}`] = `${right}`;
          }
      }
      for(let i = 2;i<4;i++){ //eslint-disable-line
          for(let x = 0;x<=10;x++) { //eslint-disable-line
            let listItem = '';
            let left = '';
            let right = '';
              listItem = `${i + "." + x}`; // eslint-disable-line
            if (x === 10) {
                  listItem = `${i+1}.0`; // eslint-disable-line
            }
            left = listItem;
            right = listItem;
            if (listItem === '2.0') { left = '2.0'; right = '2.0 or higher'; } else if (listItem === '4.0') { left = '4.0'; right = '4.0 or Higher'; }
            gpaSuggestions[`${left}`] = `${right}`;
          }
      }
    const { heightInchesErrorMessage, heightInFeetErrorMessage,
            weightErrorMessage, offensiveErrorMessage, defensiveErrorMessage,
            studentFullNameErrorMessage, studentStateErrorMessage, studentCityErrorMessage,
            t40ErrorMessage, squatsErrorMessage, specialTeamsErrorMessage,
            benchErrorMessage, satErrorMessage, gpaErrorMessage,
            schoolErrorMessage, yearOfPassingErrorMessage, actErrorMessage,
            twitterErrorMessage, mobileErrorMessage, secondaryOffensiveError,
            instagramErrorMessage, primary_offensive_position_pref, primary_defensive_position_pref,
            secondary_offensive_position_pref, secondary_defensive_position_pref,
            special_teams, secondaryDefensiveError, hbcu } = this.state;

    const renderLoader = renderIf(this.props.saRequested || this.props.updateRequested);
    return (
      <div className={cn('col s12', styles.container)}>
        {renderLoader(
          <FullScreenLoader />,
                )}
        <div className={cn('col s12', styles.collapseContainer)}>
          <Collapsible
            trigger="Student Info"
            easing={'cubic-bezier(0.175, 0.885, 0.32, 2.275)'}
            transitionTime={100}
            contentOuterClassName={styles.bottomPadding}
            open={this.state.parentCollapsible}
          >
            <div className={styles.inputContainer}>
              <div className={cn('col s12 m10', styles.personalInfo)}>
                <div className={studentFullNameErrorMessage === '' ? cn('col s12 m6', styles.halfWidthWithSpan) : cn('col s12 m6', styles.halfWidthWithSpanError)}>
                  <span>FULL NAME</span>
                  <Input
                    type="text"
                    name="full_name"
                    value={this.state.studentFullName}
                    onFocus={() => this.removeErrorMessage('studentFullNameErrorMessage')}
                    onChange={val => this.handleChange('studentFullName', val)}
                  />
                  <Error message={this.state.studentFullNameErrorMessage} />
                </div>
                <div className={cn('col s12 m6', styles.halfWidthWithSpan)}>
                  <span>EMAIL</span>
                  <Input
                    value={this.state.email}
                    disabled
                  />
                  <Error message={this.state.studentStateErrorMessage} />
                </div>
                <div className={mobileErrorMessage === '' ? cn('col s12 m6', styles.halfWidthWithSpan) : cn('col s12 m6', styles.halfWidthWithSpanError)}>
                  <span>MOBILE</span>
                  <Input
                    type="text"
                    name="mobile"
                    value={this.state.mobile}
                    onFocus={() => this.removeErrorMessage('mobileErrorMessage')}
                    onChange={val => this.handleChange('mobile', val)}
                  />
                  <Error message={mobileErrorMessage} />
                </div>
                <div className={studentStateErrorMessage === '' ? cn('col s12 m6', styles.halfWidthWithSpan) : cn('col s12 m6', styles.halfWidthWithSpanError)}>
                  <span>STATE</span>
                  <Autocomplete
                    onChange={val => this.handleChange('studentState', val)}
                    onQueryChange={val => this.handleChange('studentState', val)}
                    source={this.state.studentState === '' ? emptyObject : states}
                    value={this.state.studentState}
                    multiple={false}
                    onFocus={() => this.removeErrorMessage('studentStateErrorMessage')}
                  />
                  <Error message={this.state.studentStateErrorMessage} />
                </div>
                <div className={studentCityErrorMessage === '' ? cn('col s12 m6', styles.halfWidthWithSpan) : cn('col s12 m6', styles.halfWidthWithSpanError)}>
                  <span>CITY</span>
                  <Input
                    type="text"
                    name="full_name"
                    value={this.state.studentCity}
                    onFocus={() => this.removeErrorMessage('studentCityErrorMessage')}
                    onChange={val => this.handleChange('studentCity', val)}
                  />
                  <Error message={this.state.studentCityErrorMessage} />
                </div>
                <div className={twitterErrorMessage === '' ? cn('col s12 m6', styles.halfWidthWithSpan) : cn('col s12 m6', styles.halfWidthWithSpanError)}>
                  <span>TWITTER
                    <spann className={styles.optionalTag}>&nbsp;&nbsp;&nbsp;(Optional)</spann>
                  </span>
                  <Input
                    type="text"
                    name="twitter"
                    value={this.state.twitter}
                    onFocus={() => this.removeErrorMessage('twitterErrorMessage')}
                    onChange={val => this.handleChange('twitter', val)}
                  />
                  <Error message={twitterErrorMessage} />
                </div>
                <div className={instagramErrorMessage === '' ? cn('col s12 m6', styles.halfWidthWithSpan) : cn('col s12 m6', styles.halfWidthWithSpanError)}>
                  <span>INSTAGRAM
                    <spann className={styles.optionalTag}>&nbsp;&nbsp;&nbsp;(Optional)</spann>
                  </span>
                  <Input
                    type="text"
                    name="instagram"
                    value={this.state.instagram}
                    onFocus={() => this.removeErrorMessage('instagramErrorMessage')}
                    onChange={val => this.handleChange('instagram', val)}
                  />
                  <Error message={instagramErrorMessage} />
                </div>
                <div className={cn('col s12 m6', styles.halfWidthRadio)}>
                  <p>ARE YOU INTERESTED IN ATTENDING HBCUs?
                    (Historically Black Colleges/Universities)
                  </p>
                  <div className={cn('col s4', styles.removePadding)}>
                    <RadioGroup name="hbcu" value={hbcu} onChange={val => this.handleChange('hbcu', val)}>
                      <RadioButton label="Yes" value="yes" />
                    </RadioGroup>
                  </div>
                  <div className={cn('col s4', styles.radioContainer)} >
                    <RadioGroup name="hbcu" value={hbcu} onChange={val => this.handleChange('hbcu', val)} >
                      <RadioButton label="No" value="no" />
                    </RadioGroup>
                  </div>
                </div>
              </div>
            </div>
          </Collapsible>
          <div className={styles.space} />
          <Collapsible
            trigger="Sports Info"
            transitionTime={100}
            contentOuterClassName={styles.bottomPadding}
            open={this.state.parentCollapsible}
          >
            <div className={styles.inputContainer}>
              <div className={cn('col s12 m10', styles.removeLeftPadding)}>
                <div className={cn('col s12', styles.heightAndWidthContainer)}>
                  <div className={cn('col s12 m6', styles.heightWidth)}>
                    <span>HEIGHT</span>
                    <div className={cn('col s12', styles.heightContainer)}>
                      <div className={cn('col s6', styles.feetContainer)}>
                        <input
                          className={heightInFeetErrorMessage === '' ? cn('col s12', styles.simpleInput) : cn('col s12', styles.simpleInputError)}
                          type="text"
                          placeholder="Feet"
                          value={this.state.heightInFeet}
                          onFocus={() => this.removeErrorMessage('heightInFeetErrorMessage')}
                          onChange={val => this.handleHeight('heightInFeet', val)}
                        />
                        <Error message={heightInFeetErrorMessage} />
                      </div>
                      <div className={cn('col s6', styles.inchesContainer)}>
                        <input
                          className={heightInchesErrorMessage === '' ? cn('col s12', styles.simpleInput) : cn('col s12', styles.simpleInputError)}
                          type="text"
                          placeholder="Inches"
                          value={this.state.heightInInches}
                          onFocus={() => this.removeErrorMessage('heightInchesErrorMessage')}
                          onChange={val => this.handleHeight('heightInInches', val)}
                        />
                        <Error message={heightInchesErrorMessage} />
                      </div>
                    </div>
                    {/* <input
                         className={cn('col s12', styles.simpleInput)}
                         type="text"
                         placeholder="example 5'8''"
                         value={this.state.height}
                         onChange={val => this.handleHeightWidth('height', val)}
                         /> */}
                  </div>
                  <div className={weightErrorMessage === '' ? cn('col s12 m6', styles.halfWidthWithSpan) : cn('col s12 m6', styles.halfWidthWithSpanError)}>
                    <span>WEIGHT</span>
                    <input
                      className={cn('col s12', styles.simpleInput)}
                      value={this.state.weight}
                      onChange={val => this.handleWeight('weight', val)}
                      onFocus={() => this.removeErrorMessage('weightErrorMessage')}
                      placeholder="Pounds"
                    />
                    <Error message={this.state.weightErrorMessage} />
                  </div>
                </div>
                <div className={cn('col s12', styles.fullWidth)}>
                  <div className={cn('col s12 m6', styles.mysportContainer)}>
                    <span>MY SPORT</span>
                    <input
                            /* source={sports} */
                      value={this.state.sportName}
                    />
                  </div>
                  <div className={cn('col s12', styles.preferedPositionContainer)}>
                    <div className={offensiveErrorMessage === '' ? cn('col s12 m6', styles.halfWidthWithSpan) : cn('col s12 m6', styles.halfWidthWithSpanError)}>
                      <span>PRIMARY OFFENSIVE POSITION</span>
                      <Autocomplete
                        source={offensivePositions}
                        value={primary_offensive_position_pref} //eslint-disable-line
                        onChange={val => this.handleChange('primary_offensive_position_pref', val)}
                        multiple={false}
                        onQueryChange={() => this.handleQueryChange('primary_offensive_position_pref')}
                        direction={'down'}
                        onFocus={() => this.removeErrorMessage('offensiveErrorMessage')}
                      />
                      <Error message={offensiveErrorMessage} />
                    </div>
                    <div className={defensiveErrorMessage === '' ? cn('col s12 m6', styles.halfWidthWithSpan) : cn('col s12 m6', styles.halfWidthWithSpanError)}>
                      <span>PRIMARY DEFENSIVE POSITION</span>
                      <Autocomplete
                        source={defensivePositions}
                        value={primary_defensive_position_pref} //eslint-disable-line
                        onChange={val => this.handleChange('primary_defensive_position_pref', val)}
                        multiple={false}
                        onQueryChange={() => this.handleQueryChange('primary_defensive_position_pref')}
                        direction={'down'}
                        onFocus={() => this.removeErrorMessage('defensiveErrorMessage')}
                      />
                      <Error message={defensiveErrorMessage} />
                    </div>
                    <div className={cn('col s12', styles.removePadding)}>
                      <div className={cn('col s12 m6', styles.removePadding)}>
                        <div className={secondaryOffensiveError === '' ? cn('col s11 m11', styles.halfWidthWithSpan) : cn('col s11 m11', styles.halfWidthWithSpanError)}>
                          <span>SECONDARY OFFENSIVE POSITION
                            <spann className={styles.optionalTag}>&nbsp;&nbsp;&nbsp;
                              (Optional)
                            </spann>
                          </span>
                          <Autocomplete
                            source={offensivePositions}
                          value={secondary_offensive_position_pref} // eslint-disable-line
                            onChange={val => this.handleChange('secondary_offensive_position_pref', val)}
                            multiple={false}
                            onQueryChange={() => this.handleQueryChange('secondary_offensive_position_pref')}
                            direction={'down'}
                            onFocus={() => this.removeErrorMessage('defensiveErrorMessage')}
                          />
                          <Error message={secondaryOffensiveError} />
                        </div>
                        <div className={cn('col s1 m1', styles.removePadding)}>
                          <button
                            className={styles.removeButton}
                            onClick={() => this.removeSecondaryPosition('secondary_offensive_position_pref')}
                          >
                            <img src="https://media.dev.myrecruitboard.com/Images/redCross.png" alt="remove" />
                          </button>
                        </div>
                      </div>
                      <div className={cn('col s12 m6', styles.removePadding)}>
                        <div className={secondaryDefensiveError === '' ? cn('col s11 m11', styles.halfWidthWithSpan) : cn('col s11 m11', styles.halfWidthWithSpanError)}>
                          <span>SECONDARY DEFENSIVE POSITION
                            <spann className={styles.optionalTag}>&nbsp;&nbsp;&nbsp;
                              (Optional)
                            </spann>
                          </span>
                          <Autocomplete
                            source={defensivePositions}
                          value={secondary_defensive_position_pref} // eslint-disable-line
                            onChange={val => this.handleChange('secondary_defensive_position_pref', val)}
                            multiple={false}
                            onQueryChange={() => this.handleQueryChange('secondary_defensive_position_pref')}
                            direction={'down'}
                            onFocus={() => this.removeErrorMessage('secondaryDefensiveError')}
                          />
                          <Error message={secondaryDefensiveError} />
                        </div>
                        <div className={cn('col s1 m1', styles.removePadding)}>
                          <button
                            className={styles.removeButton}
                            onClick={() => this.removeSecondaryPosition('secondary_defensive_position_pref')}
                          >
                            <img src="https://media.dev.myrecruitboard.com/Images/redCross.png" alt="remove" />
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className={cn('col s12', styles.removePadding)}>
                      <div className={specialTeamsErrorMessage === '' ? cn('col s11 m5', styles.halfWidthWithSpan) : cn('col s11 m5', styles.halfWidthWithSpanError)}>
                        <span>SPECIAL TEAMS
                          <spann className={styles.optionalTag}>&nbsp;&nbsp;&nbsp;(Optional)</spann>
                        </span>
                        <Autocomplete
                          source={specialTeamsPositions}
                          value={special_teams} // eslint-disable-line
                          onChange={val => this.handleChange('special_teams', val)}
                          multiple={false}
                          onQueryChange={() => this.handleQueryChange('special_teams')}
                          selectedPosition="up"
                          direction="up"
                          onFocus={() => this.removeErrorMessage('specialTeamsErrorMessage')}
                        />
                        <Error message={specialTeamsErrorMessage} />
                      </div>
                      <div className={cn('col s1 m1', styles.removePadding)}>
                        <button
                          className={styles.removeButton}
                          onClick={() => this.removeSecondaryPosition('special_teams')}
                        >
                          <img src="https://media.dev.myrecruitboard.com/Images/redCross.png" alt="remove" />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={styles.fullWidth}>
                  <div className={t40ErrorMessage === '' ? cn('col s12 m6', styles.halfWidthWithSpan) : cn('col s12 m6', styles.halfWidthWithSpanError)}>
                    <span>40-YARD DASH</span>
                    <Autocomplete
                      source={this.state.t40 === '' ? emptyObject : t40Suggestions}
                      multiple={false}
                      allowCreate
                      selectedPosition={'up'}
                      direction={'up'}
                      value={this.state.t40}
                      onChange={val => this.handleChange('t40', val)}
                      onQueryChange={val => this.handleQueryChangeT40(val)}
                            /* onQueryChange={() => this.handleQueryChange('t40')} */
                      onFocus={() => this.removeErrorMessage('t40ErrorMessage')}
                      theme={theme}
                    />
                    <Error message={t40ErrorMessage} />
                  </div>
                  <div className={squatsErrorMessage === '' ? cn('col s12 m6', styles.halfWidthWithSpan) : cn('col s12 m6', styles.halfWidthWithSpanError)}>
                    <span>SQUATS MAXIMUM</span>
                    <Autocomplete
                      source={this.state.squats === '' ? emptyObject : squatsSuggestions}
                      allowCreate
                      multiple={false}
                      value={this.state.squats}
                      selectedPosition="up"
                      direction="up"
                      onChange={val => this.handleChange('squats', val)}
                      onQueryChange={val => this.handleChange('squats', val)}
                      theme={theme}
                    />
                    <Error message={squatsErrorMessage} />
                  </div>
                </div>
                <div className={cn('col s12', styles.fullWidth)}>
                  <div className={benchErrorMessage === '' ? cn('col s12 m6', styles.halfWidthWithSpan) : cn('col s12 m6', styles.halfWidthWithSpanError)}>
                    <span>BENCH MAXIMUM</span>
                    <Autocomplete
                      source={this.state.bench === '' ? emptyObject : benchSuggestions}
                      value={this.state.bench}
                      multiple={false}
                      allowCreate
                      selectedPosition="up"
                      direction="up"
                      onChange={val => this.handleChange('bench', val)}
                      onQueryChange={val => this.handleChange('bench', val)}
                      theme={theme}
                      onFocus={() => this.removeErrorMessage('benchErrorMessage')}
                    />
                    <Error message={benchErrorMessage} />
                  </div>
                </div>
              </div>
            </div>
          </Collapsible>
          <div className={styles.space} />
          <xx className={styles.academicInfo}>
            Academic info
           </xx>
          <div className={cn('col s12', styles.removePadding)}>
            <div className={styles.inputContainer}>
              <div className={cn('col s12 m10', styles.removeLeftPadding)}>
                <div className={schoolErrorMessage === '' ? cn('col s12 m6', styles.halfWidthAutoComplete) : cn('col s12 m6', styles.halfWidthAutoCompleteError)}>
                  <span>HIGH SCHOOL</span>
                  <div className={styles.autoCompleteContainer}>
                    <AutocompleteReact
                      menuStyle={autostyle}
                      inputProps={{ name: 'School', id: 'schools-autocomplete' }}
                      ref="schools-autocomplete" // eslint-disable-line
                      value={this.state.school}
                      items={this.state.schoolNames}
                      getItemValue={item => item.value}
                      onFocus={() => this.removeErrorMessage('schoolErrorMessage')}
                      onSelect={(school, item) => {
                          // set the menu to only the selected item
                        this.setState({ school: item.value });
                          // or you could reset it to a default list again
                          // this.setState({ unitedStates: getStates() })
                      }}
                      onChange={(event, value) => {
                        if (this.timer) { clearTimeout(this.timer); }

                        this.setState({ ...this.state, school: value, schoolErrorMessage: '' });

                        if (value && value.length >= 3) {
                          this.timer = setTimeout(() => {
                            this.props.searchSchools(value);
                          }, 100);
                        }
                      }}
                      renderItem={item => (
                        <div
                          key={item.key}
                          id={item.key}
                        >{item.value}</div>
                      )}
                    />
                    <Error message={schoolErrorMessage} />
                  </div>
                </div>
                <div className={yearOfPassingErrorMessage === '' ? cn('col s12 m6', styles.halfWidthAutoComplete) : cn('col s12 m6', styles.halfWidthAutoCompleteError)}>
                  <span>GRADUATION YEAR</span>
                  <Input
                    type="text"
                    name="city"
                    value={this.state.yearOfPassing}
                    onChange={val => this.handleChange('yearOfPassing', val)}
                    onFocus={() => this.removeErrorMessage('yearOfPassingErrorMessage')}
                  />
                  <Error message={yearOfPassingErrorMessage} />
                </div>
                <div className={gpaErrorMessage === '' ? cn('col s12 m6', styles.halfWidthAutoComplete) : cn('col s12 m6', styles.halfWidthAutoCompleteError)}>
                  <span>GPA</span>
                  <Autocomplete
                    source={this.state.gpa === '' ? emptyObject : gpaSuggestions}
                    value={this.state.gpa}
                    multiple={false}
                    allowCreate
                    selectedPosition="up"
                    direction="down"
                    onQueryChange={val => this.handleChange('gpa', val)}
                    theme={theme}
                    onChange={val => this.handleChange('gpa', val)}
                    onFocus={() => this.removeErrorMessage('gpaErrorMessage')}
                  />
                  <Error message={gpaErrorMessage} />
                </div>
                <div className={satErrorMessage === '' ? cn('col s12 m6', styles.halfWidthAutoComplete) : cn('col s12 m6', styles.halfWidthAutoCompleteError)}>
                  <span>SAT
                    <spann className={styles.optionalTag}>&nbsp;&nbsp;&nbsp;(Optional)</spann>
                  </span>
                  <Autocomplete
                    source={this.state.sat === '' ? emptyObject : satSuggestions}
                    value={this.state.sat}
                    multiple={false}
                    allowCreate
                    selectedPosition="up"
                    direction="down"
                    onQueryChange={val => this.handleChange('sat', val)}
                    theme={theme}
                    onChange={val => this.handleChange('sat', val)}
                    onFocus={() => this.removeErrorMessage('satErrorMessage')}
                  />
                  <Error message={satErrorMessage} />
                </div>
                <div className={actErrorMessage === '' ? cn('col s12 m6', styles.halfWidthAutoComplete) : cn('col s12 m6', styles.halfWidthAutoCompleteError)}>
                  <span>ACT
                    <spann className={styles.optionalTag}>&nbsp;&nbsp;&nbsp;(Optional)</spann>
                  </span>
                  <Autocomplete
                    source={this.state.act === '' ? emptyObject : actSuggestions}
                    value={this.state.act}
                    multiple={false}
                    allowCreate
                    selectedPosition="up"
                    direction="down"
                    onQueryChange={val => this.handleChange('act', val)}
                    theme={theme}
                    onChange={val => this.handleChange('act', val)}
                    onFocus={() => this.removeErrorMessage('actErrorMessage')}
                  />
                  <Error message={actErrorMessage} />
                </div>
              </div>
            </div>
          </div>
          <div className={cn('col s12', styles.space)} />
          <Button className={styles.continue} onClick={this.validateInput}>UPDATE PROFILE</Button>
        </div>
      </div>
    );
  }
}

export default ModifyProfile;



// WEBPACK FOOTER //
// ./src/components/ModifyStudent/ModifyStudent.js